import productcard from 'js/modules/vue/components/products/products';

export default {
    name: 'multipleproducts',
    data() {
        return {
            products: [],
            dislpayAmount: 4,
            display: 4,
            moreparts: false,
        };
    },
    props: ['parts', 'promo', 'logo'],
    created: function () {
        const getParts = this.parts.split(',');
        this.products = getParts.map((el) => {
            return {
                number: el,
                logo: this.logo,
                promo: this.promo,
            };
        });
    },
    mounted: function () {
        this.moreparts = this.dislpayAmount >= this.products.length ? false : true;
    },
    methods: {
        loadMore() {
            this.display += this.dislpayAmount;
            if (this.display >= this.products.length) {
                this.moreparts = false;
            }
        },
    },
    components: {
        productcard: productcard,
    },
    template: `
    <div>
      <div id="mult-products" class="two-col">
        <div class="prod-col" v-for="(part, index) in products" v-if="index < display">
          <productcard v-bind:part="part.number" v-bind:logo="part.logo" v-bind:promo="part.promo"></productcard>
        </div>
      </div>
      <center>
        <button class="load__more" v-on:click="loadMore" v-if="moreparts">Load More</button>
        <span v-if="!moreparts">No More Parts</span>
      </center>
    </div>
    `,
};
